export default __webpack_public_path__ + "static/media/af.46167d8f.svg";